import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ReactiveFormsModule, UntypedFormGroup } from "@angular/forms";

import { LanguageModule } from "@intocare/language";

@Component({
	selector: "custom-form-textarea",
	imports: [LanguageModule, ReactiveFormsModule],
	template: `
		<div class="dynamic-field form-textarea" [formGroup]="group">
			<label>
				<ng-content select="h3" />

				<textarea
					[formControlName]="config.name"
					[maxlength]="config.maxLength"
					[minlength]="config.minLength"
					[placeholder]="placeholder | language"
				>
				</textarea>
			</label>
		</div>
	`,
	styleUrls: ["textarea.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormTextAreaComponent {
	@Input() config: any;
	@Input() group: UntypedFormGroup;

	get placeholder() {
		return this.config.placeholder || "";
	}
}
